// extracted by mini-css-extract-plugin
export default {"Container":"AutoManual_Container__q46fN","ContainerManual":"AutoManual_ContainerManual__8wST4"};